import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/top.svg'
import _imports_1 from '@/assets/images/apple.svg'
import _imports_2 from '@/assets/images/google.svg'


const _hoisted_1 = { class: "download-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "download-page__banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "top-image"
  })
], -1)
const _hoisted_3 = { class: "download-page__page-content" }
const _hoisted_4 = { class: "download-page__page-content__links" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "link apple",
  href: "https://apps.apple.com/us"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_6 = { class: "divider" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "link google",
  href: "https://play.google.com/store/apps"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_heading_2 = _resolveComponent("heading-2")!
  const _component_subtitle_1 = _resolveComponent("subtitle-1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_heading_2, { class: "download-page__page-content__title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('general.download-app-title', 'Download the app')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_subtitle_1, { class: "download-page__page-content__subtitle" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(
						'general.download-app-subtitle',
						"Unfortunately we don't support mobile in the browser, please download our app."
					)), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_subtitle_1, { class: "line-text" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.or', 'or')), 1)
            ]),
            _: 1
          }),
          _hoisted_8
        ]),
        _hoisted_9
      ])
    ])
  ]))
}